<template>
  <v-layout>
    <v-flex>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Rewards Club Royale
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="clients"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Clients..."
          item-key="id"
          no-data-text="No Clients Found"
          :options.sync="options"
          :item-class="itemRowBackground"
          ref="table">

          <template v-slot:[`item.name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-account-outline
              </v-icon>
              {{ item.name }}
            </div>
          </template>

          <template v-slot:[`item.email`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-2">
                mdi-email-outline
              </v-icon>
              {{ item.email }}
            </div>
          </template>

          <template v-slot:[`item.sales_agent_name`]="{ item }">
            <div v-if="item.sales_agent_name" class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-face-agent
              </v-icon>
              {{ item.sales_agent_name }}
            </div>
          </template>

          <template v-slot:[`item.warehouse_id`]="{ item }">
            {{ getWarehouseName(item.warehouse_id) }}
          </template>

          <template v-slot:[`item.total_points`]="{ item }">
            {{ formatNumberAmount($numeral, item.total_points) }}
          </template>

          <template v-slot:[`item.used_points`]="{ item }">
            {{ formatNumberAmount($numeral, item.used_points) }}
          </template>

          <template v-slot:[`item.remaining_points`]="{ item }">
            {{ formatNumberAmount($numeral, remainingBalance(item.total_points, item.used_points)) }}
          </template>



          <template v-slot:[`item.status`]="{ item }">
            <span>
              <v-chip text-color="white" v-if="item.status == 0" small><strong>{{ getStatusName(item.status) }}</strong></v-chip>
              <v-chip text-color="white" color="success" v-if="item.status == 1" small><strong>{{ getStatusName(item.status) }}</strong></v-chip>
              <v-chip text-color="white" color="warning" v-if="item.status == 2" small><strong>{{ getStatusName(item.status) }}</strong></v-chip>
            </span>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:[`item.updated_at`]="{ item }">
            {{ item.updated_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="mr-2"
                  color="primary"
                  @click="editItem(item.slug, '')">
                  mdi-magnify
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'

  export default {
    name: 'AccountingClientsPage',
    data() {
      return {
        adminNamespace: 'admin',
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        clients: [],
        agents: [],
        warehouses: [],
        statuses: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
            sortable: false
          },
          {
            text: 'Email',
            align: 'start',
            value: 'email',
            sortable: false
          },
          {
            text: 'Contact No.',
            align: 'start',
            value: 'contact_no',
            sortable: false
          },
          {
            text: 'Accumulated Points',
            align: 'center',
            value: 'total_points',
            sortable: false
          },
          {
            text: 'Used Points',
            align: 'center',
            value: 'used_points',
            sortable: false
          },
          {
            text: 'Remaining Points',
            align: 'center',
            value: 'remaining_points',
            sortable: false
          },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false,
            width: 80
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumberAmount', 'formatNumberAmountNoComma']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getClients()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getClients()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      remainingBalance(total_points, used_points) {
        return Number(this.formatNumberAmountNoComma(this.$numeral, total_points)) - Number(this.formatNumberAmountNoComma(this.$numeral, used_points))
      },
      itemRowBackground: function (item) {
         return item.status > 0 ? '' : ''
      },
      getAgentName: function(id){
        let agents = this.agents.filter(agent => {
          return agent.id == id
        })
        if(agents.length > 0){
          let agent = agents[0]
          return agent.first_name + ' ' + agent.last_name
        }
      },
      getWarehouseName: function(id){
        let warehouses = this.warehouses.filter(warehouse => {
          return warehouse.id == id
        })
        if(warehouses.length > 0){
          return warehouses[0].name
        }
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get(this.adminNamespace+'/default-data?agents=true&warehouses=true&user_statuses=true')
          .then(response => {
            this.agents = response.data.agents
            this.warehouses = response.data.warehouses
            this.statuses = response.data.user_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      editItem (slug, editType) {
        this.$router.push({ name: 'rewards-clients-view', params: { slug: slug } })
      },
      getClients () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        if (this.search.length > 0){
          params.push('&search='+this.search)
        }

        // if(!this.firstLoad){
        //   this.$router.push({ name: 'clients-page', params: { page: page }})
        // }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/clients?status=1&page='+ page + '&per_page=' + itemsPerPage + params.join())
          .then(response => {
            this.clients = response.data.clients

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.query.added){
        this.showMessage(this.$route.query.message, 'success')
        this.$router.push({ name: 'clients' })
      }

      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      this.getDefaultData()

    },
    components: {
      SnackBar
    },
  }
</script>
